import {Component, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ButtonsTranslations} from '~shared/components/buttons/buttons-translations.service';
import {TixxSelectService, PriceCategoryService, StorageService} from '../../services';
import {Club, Lottery} from '../../models';
import {EventAdministrationService} from "~features/tixx-select/event-administration.service";

/**
 * Shell that operates with a customer
 */
@UntilDestroy()
@Component({
  selector: 'app-tixx-select-shell',
  templateUrl: './tixx-select-shell.component.html'
})
export class TixxSelectShellComponent implements OnDestroy {
  public selectedLottery: Lottery;
  public selectedClub: Club;

  constructor(
    private tixxSelectService: TixxSelectService,
    private storageService: StorageService,
    public buttonsTranslations: ButtonsTranslations,
    public tixxSelectOverviewService: EventAdministrationService,
    private priceCategoryService: PriceCategoryService,
    public router: Router,
  ) {
    this.tixxSelectService.castSelectedLottery.pipe(untilDestroyed(this))
      .subscribe((lottery: Lottery) => this.selectedLottery = lottery);
    this.storageService.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe((club: Club) => this.selectedClub = club);
  }

  public ngOnDestroy(): void {
    this.tixxSelectService.savedFilters.set(null);
    this.tixxSelectService.setSelectedLottery(null);
    this.priceCategoryService.setCurrentPriceCategoriesList(null);
    this.priceCategoryService.setCurrentPriceCategory(null);
  }
}
